export const CAROUSEL_LEFT = [
  { bg: "linear-gradient(135deg,#dcf9cf,#a8e0a0)", label: "Fresh Cut Lawn" },
  { bg: "linear-gradient(135deg,#e29cb4,#f5c6d8)", label: "Garden Design" },
  { bg: "linear-gradient(135deg,#a8e0a0,#dcf9cf)", label: "Hedge Trimming" },
];

export const CAROUSEL_RIGHT = [
  {
    bg: "linear-gradient(135deg,#f5c6d8,#e29cb4)",
    name: "Kiara Alexis ",
    review:
      "Great work! Attention to detail and reasonable. Would recommend for lawn care.",
    rating: "⭐⭐⭐⭐⭐",
  },
  {
    bg: "linear-gradient(135deg,#b8f0c8,#dcf9cf)",
    name: "Brendon Spencer",
    review:
      "On time, fair priced, and does quality work. Highly recommend Zayd for your lawn care services.",
    rating: "⭐⭐⭐⭐⭐",
  },
  {
    bg: "linear-gradient(135deg,#e29cb4,#c97090)",
    name: "Lori Stemmer",
    review:
      "Zayd came and took care of my backyard, which needed some serious attention after the leaves and pollen fell. Everything looks so nice again! 😊",
    rating: "⭐⭐⭐⭐⭐",
  },
  {
    bg: "linear-gradient(135deg,#dcf9cf,#a8e0a0)",
    name: "Javier Arreola",
    review:
      "I’ve been very happy with the service I’ve received for the past few months. Great service every time, and when the weather isn’t cooperating, I receive punctual communications letting me know when I’ll receive service. Also, when I’ve had questions about my lawn I get professional and courteous suggestions.",
    rating: "⭐⭐⭐⭐⭐",
  },
  {
    bg: "linear-gradient(135deg,#e29cb4,#f5c6d8)",
    name: "Alex Johnson",
    review: "Excellent service and very professional.",
    rating: "⭐⭐⭐⭐⭐",
  },
];
